<template>
  <li class="MenuItemBullet">
    <div
      class="MenuItemBullet-IconContainer"
      @click="openRoute"
    >
      <the-icon
        :icon="icon"
        class="MenuItemBullet-Icon"
      />
    </div>

    <div class="MenuItemBullet-LinkContainer">
      <a
        :title="description"
        :class="[
          { 'MenuItemBullet-Link--current': active },
          `MenuItemBullet-Link--${colorScheme}`,
        ]"
        class="MenuItemBullet-Link"
        @click="openRoute"
      >{{ title }}</a>
    </div>
  </li>
</template>

<style lang="scss" scoped>
  @import "~@/styles/_variables.scss";

  .MenuItemBullet {
    display: flex;
    align-items: center;
    margin: 10px 0;

    &-IconContainer {
      flex: 0 0 64px;
      margin: 5px 10px;
      background-color: $color-button-primary-background;
      border-radius: 100px;
      width: 64px;
      height: 64px;
      text-align: center;
    }

    &-Icon {
      position: relative;
      top: 15px;
      color: $color-button-primary-foreground;
      font-size: 36px;
    }

    &-LinkContainer {
      flex: 1 1 auto;
    }

    &-Link {
      font-weight: bold;
      font-size: 28px;

      &--current {
        font-weight: bold;
      }

      &--light {
        color: $foreground-light-color;

        &:hover {
          color: $foreground-tertiary-color;
          text-decoration: none;
        }

        &:active {
          color: $foreground-secondary-color;
        }
      }

      &--dark {
        color: $color-button-primary-background;
      }
    }
  }
</style>

<script>
  import ICON_CLASS_MAP from "@/common/icons";
  import TheIcon from "@/components/TheIcon";

  export default {
    name: "MenuItemBullet",

    components: {
      TheIcon,
    },

    props: {
      colorScheme: {
        type: String,
        default: "light",
        validator: function(value) {
          return ["light", "dark"].indexOf(value) !== -1;
        },
      },

      path: {
        type: String,
        default: "#",
      },

      name: {
        type: String,
        default: "self",
      },

      title: {
        type: String,
        default: "Self",
      },

      description: {
        type: String,
        default: "Clique para seguir o link",
      },

      icon: {
        type: String,
        default: "asterisk",
        validator: function(value) {
          return value in ICON_CLASS_MAP;
        },
      },
    },
    data() {
      return {
        active: false,
      };
    },

    watch: {
      $route(to) {
        this.active = to.path === this.path;
      },
    },

    methods: {
      openRoute(event) {
        event.preventDefault();

        if (this.path !== "#") {
          this.$router.push({ path: this.path }).catch(() => {});
        }

        this.$emit("link-open", this.name);
      },
    },
  };
</script>
